import { Helmet } from "react-helmet-async";

const SITE = "https://nhgroups.com";
const DEFAULT_IMAGE = "/media/og-nexthorizon.png";

const abs = (v) => (v?.startsWith("http") ? v : `${SITE}${v?.startsWith("/") ? "" : "/"}${v || ""}`);

// Per-page SEO: unique title, description, canonical, Open Graph + Twitter.
export const Seo = ({
  title,
  description,
  path = "/",
  image = DEFAULT_IMAGE,
  type = "website",
  noindex = false,
}) => {
  const url = `${SITE}${path === "/" ? "/" : path}`;
  const ogImage = abs(image);

  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow"} />

      <meta property="og:site_name" content="Next Horizon Builders" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};
